"use client";

import SideNavigation from "./SideNavigation/SideNavigation";
import { useMediaQuery } from "@mui/material";
import dynamic from "next/dynamic";

const BottomNavigation = dynamic(() => import("./BottomNavigation/BottomNavigation"), {
  ssr: false,
});

export default function Navigation() {
  const isTabletOrMobile = useMediaQuery("only screen and (max-width: 1024px)");

  return <>{isTabletOrMobile ? <BottomNavigation /> : <SideNavigation />}</>;
}
